import React from 'react';

import ButtonLoader from './button-loader';
import { Button, FormControlContainer, PrimaryButton } from './styled';

interface IButton extends React.ComponentPropsWithoutRef<'button'> {
	buttonType?: 'bold' | 'outlined' | undefined;
	title: string;
	load?: boolean;
	icon?: string;
	btntype?: 'primary' | 'default';
	notexthide?: boolean;
}

// eslint-disable-next-line react/display-name
export const TypeButton = React.forwardRef(({ buttonType, title, load, icon, btntype, notexthide, ...props }: IButton, ref) => {
	const isIconOnly = icon && !title;

	return (
		<FormControlContainer>
			<BtnWrapper
				buttonType={buttonType}
				props={{
					...props,
					'aria-busy': load,
					'aria-label': isIconOnly ? props['aria-label'] || 'Button' : undefined,
				}}
				btnref={ref as React.LegacyRef<HTMLButtonElement> | undefined}
				btntype={btntype}
			>
				{!load ? (
					<span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
						{icon && (
							<span aria-hidden='true'>
								<i className={icon} />
							</span>
						)}
						<span className={icon ? (notexthide ? 'd-inline ml-2' : 'd-none d-md-inline ml-2') : ''}>{title}</span>
					</span>
				) : (
					<>
						<ButtonLoader />
						<span className='visually-hidden'>Loading...</span>
					</>
				)}
			</BtnWrapper>
		</FormControlContainer>
	);
});

interface IBW {
	buttonType?: 'bold' | 'outlined' | undefined;
	props: any;
	btnref?: React.LegacyRef<HTMLButtonElement> | undefined;
	btntype?: 'primary' | 'default';
	children?: any;
}

const BtnWrapper: React.FC<IBW> = ({ buttonType, props, btnref, btntype, children }) => (
	<>
		{btntype === 'primary' ? (
			<PrimaryButton
				btntype={buttonType}
				type='button'
				{...props}
				ref={btnref}
			>
				{children}
			</PrimaryButton>
		) : (
			<Button
				btntype={buttonType}
				type='button'
				{...props}
				ref={btnref}
			>
				{children}
			</Button>
		)}
	</>
);
